import Fraction from 'fraction.js'

import { otherValue } from '../../shared/constants/general-enums/value-other'

const fractionalNumberRegExp = /^(?:\d+|\d+\/\d+|\d+-\d+\/\d+)$/
const decimalNumberRegExp = /^\d+(\.\d+)?$/

export const convertFullNumberFractionToDecimal = (fractionalString: string): string | null => {
    if (fractionalString === otherValue) {
        return fractionalString
    }
    if (!fractionalNumberRegExp.test(fractionalString)) {
        return null
    }
    let wholeNumber = 0
    let fraction = ''

    if (fractionalString.includes('-')) {
        wholeNumber = Number(fractionalString.split('-')[0])
        fraction = fractionalString.split('-')[1]
    } else {
        fraction = fractionalString
    }

    if (!fraction.includes('/')) {
        return fractionalString
    }

    const decimal = Number(fraction.split('/')[0]) / Number(fraction.split('/')[1])

    return (wholeNumber + decimal).toString()
}

export const convertDecimalToFullNumberFraction = (decimalString: string): string => {
    if (decimalString === otherValue) {
        return decimalString
    }
    if (!decimalNumberRegExp.test(decimalString)) {
        throw new Error('Invalid decimal number input')
    }
    if (!decimalString.includes('.')) {
        return decimalString
    }

    return new Fraction(Number(decimalString)).simplify(0.000001).toFraction(true).replaceAll(' ', '-')
}

export function truncateToDecimals(trunkNum: number | string, decimals = 3): string {
    const num: number = typeof trunkNum === 'string' ? Number(trunkNum) : trunkNum

    if (!Number.isInteger(decimals) || decimals < 0) {
        throw new RangeError('decimals must be a non-negative integer')
    }

    if (decimals === 0) return String(Math.trunc(num))

    const factor = Math.pow(10, decimals)

    return String(Math.trunc(num * factor) / factor)
}
